import React from 'react';
import { NodeProps, useReactFlow } from 'reactflow';
import { TextInput } from '../../../../form/textInput';
import { Select } from '../../../../form/select';
import { operationType, selectDataType } from '../../../../../services/types';
import { updateNodeValue } from '../../../../../services/method';
import { Main, Styled } from './style';
import { SettingsBlock, settingsDataType } from '../../../../settingsBlock';
import { ExpandedBlock } from '../../../expanded';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { Switch } from '../../../../form/switch';

type RssProps = NodeProps<operationType> & {
  setChildMinimize?: (fn: (id: string) => void) => void;
  setChildSettings?: (fn: (id: string) => void) => void;
};

export function RssNode({ id, data, setChildMinimize, setChildSettings }: RssProps) {
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   // const maxItemsValue = data.value?.maxItems ?? '';

   const emitModes: selectDataType[] = [
      { id: 1, name: 'Single Item', refId: 'single', isActive: data.value?.emitMode === 'single' || !data.value?.emitMode },
      { id: 2, name: 'Batch (Array)', refId: 'batch', isActive: data.value?.emitMode === 'batch' }
   ];

   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      const value = e.target.value;
      if (keyRef) updateNodeValue(id, setNodes, { [keyRef]: value });
   }

   const handleSelectEmitMode = (selectId: number) => {
      const mode = emitModes.find(m => m.id === selectId)?.refId;
      updateNodeValue(id, setNodes, { emitMode: mode });
   }

   const isWarning = !data.value?.feedUrl;

   return (<>
      <SettingsBlock nodeId={id} data={settings} setData={setSettings} />
      <Main>
         {isWarning ? <>
         <div id="warning"></div>
         <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
         <div id="ran"></div>
         <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}

         {isExpanded ?
         <ExpandedBlock
            data={{ id, ...data }}
            handleClose={() => setIsExpanded(false)}
            isWarning={isWarning}
            style={{ minWidth: '420px' }}
         >
            <Styled>
               <TextInput
               keyRef="feedUrl"
               value={data.value?.feedUrl || ''}
               title="Feed URL"
               placeholder="https://example.com/rss"
               handleChange={handleChangeInput}
               />
               {/* <TextInput
               keyRef="maxItems"
               value={
                  maxItemsValue === 0
                     ? '0'
                     : maxItemsValue === ''
                     ? ''
                     : String(maxItemsValue)
               }
               title="Max Items (optional)"
               placeholder="Defaults to 10"
               handleChange={handleChangeInput}
               type="number"
               min={1}
               /> */}
               <Select
               title="Emit Mode"
               data={emitModes}
               handleSelectItem={handleSelectEmitMode}
               isSmall={true}
               />
               <Switch
               title="Fetch only new items"
               value={!!data.value?.fetchOnlyNew}
               setValue={() => updateNodeValue(id, setNodes, { fetchOnlyNew: !data.value?.fetchOnlyNew })}
               className="autopilot"
               />
            </Styled>
         </ExpandedBlock> : null}
      </Main>
   </>);
}